export default __webpack_public_path__ + "images/12d4c0eb04630f1d492b4dac5c43a698.png";